<template>
  <b-container fluid>
    <b-form class="1w-100 form" @submit="onSubmit">
      <!-- <div class="row">
       <a-switch checked-children="Usar informações Kredit?" un-checked-children=" Não Usar informações Kredit?" default-checked />
    <br />
    <a-switch checked-children="1" un-checked-children="0" />
    <br />
    <a-switch default-checked>
      <a-icon slot="checkedChildren" type="check" />
      <a-icon slot="unCheckedChildren" type="close" />
    </a-switch>
    </div> -->
      <div class="row" v-if="!semDadosParaEdicao">
        <div class="col-md-3">
          <b-form-group
            v-if="commercialPolices.length"
            label="Política Comercial"
          >
            <a-select
              v-model="form.IdCommercialPolicy"
              @change="getCommercialPolicy"
            >
              <a-select-option :value="null">
                Selecione
              </a-select-option>
              <a-select-option
                :value="item.idSaleChannelCommercialPolicy"
                v-for="(item, index) in commercialPolices"
                :key="`policy-${index}`"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </b-form-group>
          <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
      <div class="row">
        <formulario
          v-if="item && !loading && !loadingCommercialPolicy"
          :edicao="true"
          :edicaoMerchant="true"
          :item="item"
          :showMcc="false"
          @dados="salvarDados"
        />
        <div v-else class="col-md-3">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <div class="col-md-3" v-if="loadingCommercialPolicy">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </b-form>
  </b-container>
</template>

<script>
import { get as _get, debounce as _debounce } from "lodash";
import { mask } from "@titou10/v-mask";
import { CanalDeVendasResource } from "@/resources/CanalDeVenda.resource.js";
import { MerchantNegotiationResource } from "@/resources/MerchantNegotiation.resource.js";
import Formulario from "@/views/credenciamento/politica-comercial/formulario.vue";
import { cloneObject } from "@/utils/helpers";

export default {
  directives: { mask },
  props: {
    merchantTax: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {
    Formulario
  },

  data() {
    return {
      semDadosParaEdicao: false,
      loading: false,
      loadingCommercialPolicy: false,
      commercialPolices: [],
      IdCommercialPolicy: 0,
      form: {
        IdCommercialPolicy: null
      },
      filtrosLocal: {
        index: 1,
        size: 100,
        name: ""
      },
      item: null
    };
  },

  methods: {
    async onSubmit(e) {
      e.preventDefault();

      const data = {
        ...this.form
      };
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    getCommercialPolicy(idCommercialPolicy) {
      this.loadingCommercialPolicy = true;
      CanalDeVendasResource.getPoliticaComercial({
        id: idCommercialPolicy
      })
        .then(response => {
          // tratar os dados
          if (response.data.isSuccess) {
            let itemTratado = cloneObject(response.data.payload);
            itemTratado.items = itemTratado.basePriceList;
            delete itemTratado.basePriceList;

            this.item = itemTratado;
            this.loadingCommercialPolicy = false;
          } else {
            throw "erro ao carregar politica comercial";
          }
        })
        .catch(e => {
          // Surpress
          this.loading = false;
        });
    },

    getLista(name) {
      // nessa situacao, precisamos buscar os dados, pois ainda nao forma consultados...
      this.loading = true;
      this.filtrosLocal.name = name;
      const v = this;
      CanalDeVendasResource.getListaPoliticaComercial(this.filtrosLocal)
        .then(result => {
          try {
            v.commercialPolices = result.data.payload.items;
            v.loading = false;
          } catch (e) {
            throw {
              response: {
                data: {
                  failureReason: "Deu ruim na chamada..."
                }
              }
            };
          }
        })
        .catch(e => {
          // Surpress
          // Surpress
          v.loading = false;
        });
    },

    salvarDados(dados) {
      let idMerchant = null;
      this.loading = true;
      const v = this;
      // estamos editando ou adicionando um novo?
      if (this.semDadosParaEdicao) {
        idMerchant = parseInt(this.$route.params.id);
        MerchantNegotiationResource.update({
          ...dados,
          deviceRentPromotionalEndDate: dados.deviceRentPromotionExpireDate,
          idMerchant
        })
          .then(response => {
            v.loading = false;
            v.item = null;
            v.getMerchantNegotiation(v.$route.params.id);
            v.$notification["success"]({
              message: "Dados Atualizados",
              description: "Atualização realizada com sucesso!"
            });
          })
          .catch(e => {
            v.loading = false;
            v.$notification["error"]({
              message: "Erro ao atualizar",
              description: "dados não foram atualizados"
            });
          });
      } else {
        MerchantNegotiationResource.add({
          ...dados,
          deviceRentPromotionalEndDate: dados.deviceRentPromotionExpireDate,
          idMerchant: parseInt(v.$route.params.id)
        })
          .then(response => {
            v.$notification["success"]({
              message: "Dados Salvos",
              description: "Inserção realizada com sucesso!"
            });
            v.loading = false;
            v.item = null;
            v.getMerchantNegotiation(v.$route.params.id);
            v.semDadosParaEdicao = false;
          })
          .catch(e => {
            v.loading = false;
            v.$notification["error"]({
              message: "Erro ao salvar",
              description: "dados não foram salvos"
            });
          });
      }
    },

    getMerchantNegotiation(params) {
      const v = this;
      MerchantNegotiationResource.get({ id: params })
        .then(response => {
          // se tiver, show, vamos usar estes dados para edicao
          try {
            if (response.data.isSuccess) {
              let itemTratado = cloneObject(response.data.payload);
              // itemTratado.items = itemTratado.basePriceList;
              v.semDadosParaEdicao = itemTratado !== undefined;
              v.item = {
                ...itemTratado,
                deviceRentPromotionExpireDate:
                  itemTratado.deviceRentPromotionalEndDate
              };
              v.loadingCommercialPolicy = false;
            } else {
              throw "erro ao carregar politica comercial";
            }
          } catch (e) {
            throw new Error(e);
          }
        })
        .catch(e => {
          // nao temos, entao vamos carregar a lista de dados para que ele possa selecionar uma nova politica
          v.getLista();
        });
    }
  },
  mounted() {
    // primeiro verificamos se existe algo já cadastrado para este merchant
    // eslint-disable-next-line

    const v = this;
    if (typeof this.$route.params.id === "undefined") {
      // se nao temos o item, voltamos um tela...
      this.$router.go(-1);
      return;
    }
    this.getMerchantNegotiation(this.$route.params.id);
  }
};
</script>

<style lang="css">
.width-150 {
  width: 150px;
}
.form .is-invalid,
.form .is-valid {
  padding-right: 0;
}
</style>
